/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"

import * as commonV1 from "./deviceapis_device_common_v1.pb"

/**
 * Сервис профилей шифрования устройства
 */

/**
 * Сервис профилей шифрования устройства
 */
export class EncryptionProfileServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод удаления единичной сущности EncryptionProfile по ключу
   */
  DeleteEncryptionProfile = (req: DeleteEncryptionProfileRequestDto, init?: RequestInit): Promise<DeleteEncryptionProfileResponseDto> => {
    return fm.request<DeleteEncryptionProfileRequestDto, DeleteEncryptionProfileResponseDto>(`${this.host}/device/api/v1/encryption_profile/${encodeURIComponent(req.id)}`, { ...init, method: "DELETE", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод удаления списка сущностей EncryptionProfile по фильтру
   */
  DeleteEncryptionProfileList = (req?: DeleteEncryptionProfileListRequestDto, init?: RequestInit): Promise<DeleteEncryptionProfileListResponseDto> => {
    return fm.request<DeleteEncryptionProfileListRequestDto, DeleteEncryptionProfileListResponseDto>(`${this.host}/device/api/v1/encryption_profile/list`, { ...init, method: "DELETE", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения единичной сущности EncryptionProfile по ключу
   */
  GetEncryptionProfile = (req: GetEncryptionProfileRequestDto, init?: RequestInit): Promise<GetEncryptionProfileResponseDto> => {
    return fm.request<GetEncryptionProfileRequestDto, GetEncryptionProfileResponseDto>(`${this.host}/device/api/v1/encryption_profile/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения списка сущностей EncryptionProfile по фильтру
   */
  GetEncryptionProfileList = (req?: GetEncryptionProfileListRequestDto, init?: RequestInit): Promise<GetEncryptionProfileListResponseDto> => {
    return fm.request<GetEncryptionProfileListRequestDto, GetEncryptionProfileListResponseDto>(`${this.host}/device/api/v1/encryption_profile/list${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод создания сущности EncryptionProfile
   */
  SaveEncryptionProfile = (req: SaveEncryptionProfileRequestDto, init?: RequestInit): Promise<SaveEncryptionProfileResponseDto> => {
    return fm.request<SaveEncryptionProfileRequestDto, SaveEncryptionProfileResponseDto>(`${this.host}/device/api/v1/encryption_profile`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Тип
 */
export enum EncryptionProfileType {
  /**
   * Значение не указано
   */
  TYPE_UNKNOWN = "TYPE_UNKNOWN",
  /**
   * Тип SL3
   */
  SL3 = "SL3",
  /**
   * Тип SL1
   */
  SL1 = "SL1",
}
/**
 * Тип
 */
export type EncryptionProfileTypeResponseEnum = keyof typeof EncryptionProfileType
/**
 * Тип
 */
export type EncryptionProfileTypeRequestEnum = Exclude<EncryptionProfileTypeResponseEnum, "TYPE_UNKNOWN">;

/**
 * Запрос удаления списка сущностей EncryptionProfile по фильтру
 */
export type DeleteEncryptionProfileListRequestDto = {
}
/**
 * Ответ на запрос удаления списка сущностей EncryptionProfile по фильтру
 */
export type DeleteEncryptionProfileListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Всего количество удаленных
   */
  readonly data: number
  /**
   * Ошибка
   */
  readonly error: DeleteEncryptionProfileListResponseErrorDto
}>
/**
 * Ошибка запроса
 */
export type DeleteEncryptionProfileListResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorRequestDto
  /**
   * Ошибка удаления
   */
  readonly deleting: EncryptionProfileDeletingErrorRequestDto
}>
/**
 * Ошибка запроса
 */
export type DeleteEncryptionProfileListResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorResponseDto
  /**
   * Ошибка удаления
   */
  readonly deleting: EncryptionProfileDeletingErrorResponseDto
}>
/**
 * Запрос удаления единичной сущности EncryptionProfile по ключу
 */
export type DeleteEncryptionProfileRequestDto = {
  /**
   * Идентификатор.
   * Тип: Guid
   */
  id: string
}
/**
 * Ответ на запрос удаления единичной сущности EncryptionProfile по ключу
 */
export type DeleteEncryptionProfileResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Всего количество удаленных
   */
  readonly data: number
  /**
   * Ошибка
   */
  readonly error: DeleteEncryptionProfileResponseErrorDto
}>
/**
 * Ошибка запроса
 */
export type DeleteEncryptionProfileResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorRequestDto
  /**
   * Ошибка удаления
   */
  readonly deleting: EncryptionProfileDeletingErrorRequestDto
}>
/**
 * Ошибка запроса
 */
export type DeleteEncryptionProfileResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorResponseDto
  /**
   * Ошибка удаления
   */
  readonly deleting: EncryptionProfileDeletingErrorResponseDto
}>
/**
 * Профиль шифрования
 */
export type EncryptionProfileRequestDto = {
  /**
   * Идентификатор.
   * Тип: Guid
   */
  id?: string
  /**
   * Наименование
   */
  title: string
  /**
   * Тип
   */
  type: EncryptionProfileTypeRequestEnum
  /**
   * Номер сектора
   */
  sectorNumber: number
  /**
   * Номер блока
   */
  blockNumber: number
  /**
   * Первый байт в блоке
   */
  startIndex: number
  /**
   * Последний байт в блоке
   */
  endIndex: number
  /**
   * Пароль.
   * Не возвращается с сервера.
   * TODO: в генерации сваггера не показывать INPUT_ONLY поля в ответах
   */
  password: string
}
/**
 * Профиль шифрования
 */
export type EncryptionProfileResponseDto = {
  /**
   * Идентификатор.
   * Тип: Guid
   */
  id: string
  /**
   * Наименование
   */
  title: string
  /**
   * Тип
   */
  type: EncryptionProfileTypeResponseEnum
  /**
   * Номер сектора
   */
  sectorNumber: number
  /**
   * Номер блока
   */
  blockNumber: number
  /**
   * Первый байт в блоке
   */
  startIndex: number
  /**
   * Последний байт в блоке
   */
  endIndex: number
}
/**
 * Ошибка удаления
 */
export type EncryptionProfileDeletingErrorRequestDto = {
  /**
   * Идентификатор профиля шифрования, к которому относится ошибка.
   * Тип: Guid
   */
  id: string
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Профиль используется на устройстве
   */
  readonly encryptionProfileInUse: EncryptionProfileDeletingErrorEncryptionProfileInUseRequestDto
}>
/**
 * Ошибка удаления
 */
export type EncryptionProfileDeletingErrorResponseDto = {
  /**
   * Идентификатор профиля шифрования, к которому относится ошибка.
   * Тип: Guid
   */
  id: string
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Профиль используется на устройстве
   */
  readonly encryptionProfileInUse: EncryptionProfileDeletingErrorEncryptionProfileInUseResponseDto
}>
/**
 * Профиль шифрования используется на устройстве
 */
export type EncryptionProfileDeletingErrorEncryptionProfileInUseRequestDto = {
}
/**
 * Профиль шифрования используется на устройстве
 */
export type EncryptionProfileDeletingErrorEncryptionProfileInUseResponseDto = {
}
/**
 * Ошибка сохранения.
 * Эти проверки выполняются при работе с базой данных и сторонними сервисами
 */
export type EncryptionProfileSavingErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Профиль с таким наименованием уже существует
   */
  readonly duplicateName: EncryptionProfileSavingErrorDuplicateNameRequestDto
  /**
   * Превышено допустимое количество профилей шифрования
   */
  readonly tooMuchEncryptionProfiles: EncryptionProfileSavingErrorTooMuchEncryptionProfilesRequestDto
}>
/**
 * Ошибка сохранения.
 * Эти проверки выполняются при работе с базой данных и сторонними сервисами
 */
export type EncryptionProfileSavingErrorResponseDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Профиль с таким наименованием уже существует
   */
  readonly duplicateName: EncryptionProfileSavingErrorDuplicateNameResponseDto
  /**
   * Превышено допустимое количество профилей шифрования
   */
  readonly tooMuchEncryptionProfiles: EncryptionProfileSavingErrorTooMuchEncryptionProfilesResponseDto
}>
/**
 * Профиль с таким наименованием уже существует
 */
export type EncryptionProfileSavingErrorDuplicateNameRequestDto = {
}
/**
 * Профиль с таким наименованием уже существует
 */
export type EncryptionProfileSavingErrorDuplicateNameResponseDto = {
}
/**
 * Превышено допустимое количество профилей шифрования
 */
export type EncryptionProfileSavingErrorTooMuchEncryptionProfilesRequestDto = {
}
/**
 * Превышено допустимое количество профилей шифрования
 */
export type EncryptionProfileSavingErrorTooMuchEncryptionProfilesResponseDto = {
}
/**
 * Фильтр по профилям шифрования
 */
export type EncryptionProfileFilterRequestDto = {
  /**
   * Поиск по тексту.
   * Если значение не передано то поиск по нему не производится.
   * Поиск производится по полям:
   * # - Наименование
   */
  text?: string | null
}
/**
 * Фильтр по профилям шифрования
 */
export type EncryptionProfileFilterResponseDto = {
  /**
   * Поиск по тексту.
   * Если значение не передано то поиск по нему не производится.
   * Поиск производится по полям:
   * # - Наименование
   */
  text: string | null
}
/**
 * Запрос получения списка сущностей EncryptionProfile по фильтру
 */
export type GetEncryptionProfileListRequestDto = {
  /**
   * Фильтр по профилям шифрования
   */
  filter?: EncryptionProfileFilterRequestDto | null
}
/**
 * Ответ на запрос получения списка сущностей EncryptionProfile по фильтру
 */
export type GetEncryptionProfileListResponseDto = {
  /**
   * Список EncryptionProfile
   */
  data: EncryptionProfileResponseDto[]
}
/**
 * Запрос получения единичной сущности EncryptionProfile по ключу
 */
export type GetEncryptionProfileRequestDto = {
  /**
   * Идентификатор.
   * Тип: Guid
   */
  id: string
}
/**
 * Ответ на запрос получения единичной сущности EncryptionProfile по ключу
 */
export type GetEncryptionProfileResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Профиль шифрования
   */
  readonly data: EncryptionProfileResponseDto
}>
/**
 * Запрос на создание сущности EncryptionProfile
 */
export type SaveEncryptionProfileRequestDto = {
  /**
   * Профиль шифрования
   */
  data: EncryptionProfileRequestDto
}
/**
 * Ответ на запрос на создание сущности EncryptionProfile
 */
export type SaveEncryptionProfileResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Профиль шифрования
   */
  readonly data: EncryptionProfileResponseDto
  /**
   * Ошибка
   */
  readonly error: SaveEncryptionProfileResponseErrorDto
}>
/**
 * Ошибка запроса
 */
export type SaveEncryptionProfileResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorRequestDto
  /**
   * Ошибка сохранения
   */
  readonly saving: EncryptionProfileSavingErrorRequestDto
}>
/**
 * Ошибка запроса
 */
export type SaveEncryptionProfileResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorResponseDto
  /**
   * Ошибка сохранения
   */
  readonly saving: EncryptionProfileSavingErrorResponseDto
}>
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос удаления списка сущностей EncryptionProfile по фильтру
   */
  "DeleteEncryptionProfileListRequest": {
    "kind": "class",
    "text": "Запрос удаления списка сущностей EncryptionProfile по фильтру",
  },
  /**
   * Ответ на запрос удаления списка сущностей EncryptionProfile по фильтру
   */
  "DeleteEncryptionProfileListResponse": {
    "kind": "class",
    "text": "Ответ на запрос удаления списка сущностей EncryptionProfile по фильтру",
    "fields": {
      /**
       * Всего количество удаленных
       */
      "data": {
        "type": "int32",
        "text": "Всего количество удаленных",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "DeleteEncryptionProfileListResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса
   */
  "DeleteEncryptionProfileListResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
      /**
       * Ошибка удаления
       */
      "deleting": {
        "type": "EncryptionProfile.DeletingError",
        "text": "Ошибка удаления",
      },
    },
  },
  /**
   * Запрос удаления единичной сущности EncryptionProfile по ключу
   */
  "DeleteEncryptionProfileRequest": {
    "kind": "class",
    "text": "Запрос удаления единичной сущности EncryptionProfile по ключу",
    "fields": {
      /**
       * Идентификатор.
       * Тип: Guid
       */
      "id": {
        "type": "string",
        "text": "Идентификатор.\nТип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос удаления единичной сущности EncryptionProfile по ключу
   */
  "DeleteEncryptionProfileResponse": {
    "kind": "class",
    "text": "Ответ на запрос удаления единичной сущности EncryptionProfile по ключу",
    "fields": {
      /**
       * Всего количество удаленных
       */
      "data": {
        "type": "int32",
        "text": "Всего количество удаленных",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "DeleteEncryptionProfileResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса
   */
  "DeleteEncryptionProfileResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
      /**
       * Ошибка удаления
       */
      "deleting": {
        "type": "EncryptionProfile.DeletingError",
        "text": "Ошибка удаления",
      },
    },
  },
  /**
   * Профиль шифрования
   */
  "EncryptionProfile": {
    "kind": "class",
    "text": "Профиль шифрования",
    "fields": {
      /**
       * Идентификатор.
       * Тип: Guid
       */
      "id": {
        "type": "string",
        "text": "Идентификатор.\nТип: Guid",
      },
      /**
       * Наименование
       */
      "title": {
        "type": "string",
        "text": "Наименование",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Тип
       */
      "type": {
        "type": "EncryptionProfile.Type",
        "text": "Тип",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Номер сектора
       */
      "sectorNumber": {
        "type": "int32",
        "text": "Номер сектора",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Номер блока
       */
      "blockNumber": {
        "type": "int32",
        "text": "Номер блока",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Первый байт в блоке
       */
      "startIndex": {
        "type": "int32",
        "text": "Первый байт в блоке",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Последний байт в блоке
       */
      "endIndex": {
        "type": "int32",
        "text": "Последний байт в блоке",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Пароль.
       * Не возвращается с сервера.
       * TODO: в генерации сваггера не показывать INPUT_ONLY поля в ответах
       */
      "password": {
        "type": "string",
        "text": "Пароль.\nНе возвращается с сервера.\nTODO: в генерации сваггера не показывать INPUT_ONLY поля в ответах",
      },
    },
  },
  /**
   * Ошибка удаления
   */
  "EncryptionProfile.DeletingError": {
    "kind": "class",
    "text": "Ошибка удаления",
    "fields": {
      /**
       * Идентификатор профиля шифрования, к которому относится ошибка.
       * Тип: Guid
       */
      "id": {
        "type": "string",
        "text": "Идентификатор профиля шифрования, к которому относится ошибка.\nТип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Профиль используется на устройстве
       */
      "encryptionProfileInUse": {
        "type": "EncryptionProfile.DeletingError.EncryptionProfileInUse",
        "text": "Профиль используется на устройстве",
      },
    },
  },
  /**
   * Профиль шифрования используется на устройстве
   */
  "EncryptionProfile.DeletingError.EncryptionProfileInUse": {
    "kind": "class",
    "text": "Профиль шифрования используется на устройстве",
  },
  /**
   * Ошибка сохранения.
   * Эти проверки выполняются при работе с базой данных и сторонними сервисами
   */
  "EncryptionProfile.SavingError": {
    "kind": "class",
    "text": "Ошибка сохранения.\nЭти проверки выполняются при работе с базой данных и сторонними сервисами",
    "fields": {
      /**
       * Профиль с таким наименованием уже существует
       */
      "duplicateName": {
        "type": "EncryptionProfile.SavingError.DuplicateName",
        "text": "Профиль с таким наименованием уже существует",
      },
      /**
       * Превышено допустимое количество профилей шифрования
       */
      "tooMuchEncryptionProfiles": {
        "type": "EncryptionProfile.SavingError.TooMuchEncryptionProfiles",
        "text": "Превышено допустимое количество профилей шифрования",
      },
    },
  },
  /**
   * Профиль с таким наименованием уже существует
   */
  "EncryptionProfile.SavingError.DuplicateName": {
    "kind": "class",
    "text": "Профиль с таким наименованием уже существует",
  },
  /**
   * Превышено допустимое количество профилей шифрования
   */
  "EncryptionProfile.SavingError.TooMuchEncryptionProfiles": {
    "kind": "class",
    "text": "Превышено допустимое количество профилей шифрования",
  },
  /**
   * Фильтр по профилям шифрования
   */
  "EncryptionProfileFilter": {
    "kind": "class",
    "text": "Фильтр по профилям шифрования",
    "fields": {
      /**
       * Поиск по тексту.
       * Если значение не передано то поиск по нему не производится.
       * Поиск производится по полям:
       * # - Наименование
       */
      "text": {
        "type": "google.protobuf.StringValue",
        "text": "Поиск по тексту.\nЕсли значение не передано то поиск по нему не производится.\nПоиск производится по полям:\n# - Наименование",
      },
    },
  },
  /**
   * Запрос получения списка сущностей EncryptionProfile по фильтру
   */
  "GetEncryptionProfileListRequest": {
    "kind": "class",
    "text": "Запрос получения списка сущностей EncryptionProfile по фильтру",
    "fields": {
      /**
       * Фильтр по профилям шифрования
       */
      "filter": {
        "type": "EncryptionProfileFilter",
        "text": "Фильтр по профилям шифрования",
      },
    },
  },
  /**
   * Ответ на запрос получения списка сущностей EncryptionProfile по фильтру
   */
  "GetEncryptionProfileListResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения списка сущностей EncryptionProfile по фильтру",
    "fields": {
      /**
       * Список EncryptionProfile
       */
      "data": {
        "type": "EncryptionProfile",
        "text": "Список EncryptionProfile",
      },
    },
  },
  /**
   * Запрос получения единичной сущности EncryptionProfile по ключу
   */
  "GetEncryptionProfileRequest": {
    "kind": "class",
    "text": "Запрос получения единичной сущности EncryptionProfile по ключу",
    "fields": {
      /**
       * Идентификатор.
       * Тип: Guid
       */
      "id": {
        "type": "string",
        "text": "Идентификатор.\nТип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос получения единичной сущности EncryptionProfile по ключу
   */
  "GetEncryptionProfileResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения единичной сущности EncryptionProfile по ключу",
    "fields": {
      /**
       * Профиль шифрования
       */
      "data": {
        "type": "EncryptionProfile",
        "text": "Профиль шифрования",
      },
    },
  },
  /**
   * Запрос на создание сущности EncryptionProfile
   */
  "SaveEncryptionProfileRequest": {
    "kind": "class",
    "text": "Запрос на создание сущности EncryptionProfile",
    "fields": {
      /**
       * Профиль шифрования
       */
      "data": {
        "type": "EncryptionProfile",
        "text": "Профиль шифрования",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос на создание сущности EncryptionProfile
   */
  "SaveEncryptionProfileResponse": {
    "kind": "class",
    "text": "Ответ на запрос на создание сущности EncryptionProfile",
    "fields": {
      /**
       * Профиль шифрования
       */
      "data": {
        "type": "EncryptionProfile",
        "text": "Профиль шифрования",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "SaveEncryptionProfileResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса
   */
  "SaveEncryptionProfileResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
      /**
       * Ошибка сохранения
       */
      "saving": {
        "type": "EncryptionProfile.SavingError",
        "text": "Ошибка сохранения",
      },
    },
  },
  /**
   * Тип
   */
  "EncryptionProfile.Type": {
    "kind": "enum",
    "text": "Тип",
    "values": {
      /**
       * Значение не указано
       */
      "TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Тип SL3
       */
      "SL3": {
        "i": 1,
        "text": "Тип SL3",
      },
      /**
       * Тип SL1
       */
      "SL1": {
        "i": 2,
        "text": "Тип SL1",
      },
    },
  },
}